import React, { useState, useEffect } from 'react';
import { Form, Input, Checkbox, Button, Divider, message } from 'antd';
import { ReactComponent as GoogleLogo } from '../../../assets/icons/googleLogo.svg';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { addDefeatCount } from '../../../api/user';
import action from '../../../action/index';
import Cookies from 'js-cookie';
import Validator from '../../../utils/formValidator';
import { ReactComponent as PasswordShow } from '../../../assets/icons/showPassword.svg';
import { ReactComponent as PasswordHide } from '../../../assets/icons/hidePassword.svg';
import { api_config } from '../../../constants/api';
import axios from 'axios';
import Gverify from './Gverify';
import Utils from '../../../utils/utils';

export default function EmailLogin(props) {
  //step ==2
  const [isRemember, setIsRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [captcha, setCaptcha] = useState('');
  const [isShow, setShow] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const { t } = useTranslation(['userLoginTips']);
  const dispatch = useDispatch();
  const pidType = {
    en: 4011, //en 1
    br: 4068, //pt 葡萄牙语 1
    fr: 4072, //fr 1
    it: 4070, //it 1
    ru: 4071, //ru 1
    ar: 4069, //ar 1
    es: 4073, //es 1
    // tr: 4080, //tr
    kr: 4067, //ko 1
    jp: 4076, //ja 1
    nl: 4074, //nl 1
    de: 4075, //de 1
    tw: 4077, //tw 1
    inn: 4078, //hi 1
    id: 4079, //id 1

    // ar, cn, en, id, inn, kr, br, jp, tw, it, fr, ru, es, de, nl
  };
  const passWordIconRender = (visible) =>
    visible ? <PasswordShow /> : <PasswordHide />;
  const changeIntoSignUp = () => {
    //跳转注册表单
    props.changeStep(3);
  };
  const handleClickCaptcha = (data) => {
    setCaptcha(data);
  };
  const changeIntoForget = () => {
    //跳转忘记密码表单
    props.changeStep(4);
  };

  const onChange = (e) => {
    //checkbox 的值
    setIsRemember(e.target.checked);
  };

  const GoogleLogin = () => {
    localStorage.setItem('isFirstLogin', '1');
    localStorage.setItem('localUrl', window.location.href);
    setGoogleLoading(true);
    axios({
      method: 'POST',
      url: api_config.googleUrl,
      data: {
        pid: pidType[`${Utils.getLanguage()}`] || 4011,
        redirect_uri: window.location.href,
        token: '$2y$10$NCD4zFjrZzJvKN7YSyXIQOb/ivtITqcFKh6c08ZZ80XSGdHXdZdt.',
      },
    })
      .then((obj) => {
        let res = obj.data;
        setGoogleLoading(false);
        window.location.href = res.data.redirect;
      })
      .catch((err) => {
        setGoogleLoading(false);
        message.error(t('500'));
      });
  };

  const loginRequest = (formData, value) => {
    localStorage.setItem('isFirstLogin', '1');
    setLoading(true);
    axios({
      method: 'post',
      url: api_config.API_V2_URL + 'sessions',
      data: formData,
    })
      .then((obj) => {
        let res = obj.data;
        if (res.code === 200) {
          message.success(t('Loginsuccessful'));
          localStorage.removeItem('defeatCount');

          Cookies.set('authorization', res.data.authorization, { expires: 30 });
          let hostName = window.location.hostname;
          Cookies.set('access_token', res.data.account_access_token, {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          let expires_in = new Date().getTime() + 30 * 86400 * 1000;
          Cookies.set('access_token_expires_in', expires_in.toString(), {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          if (isRemember) {
            localStorage.setItem('userEmail', value.email);
            localStorage.setItem('userPassword', value.password);
          } else {
            localStorage.removeItem('userEmail', value.email);
            localStorage.removeItem('userPassword', value.password);
          }
          dispatch(action.loginIn(res.data));
          setLoading(false);
          dispatch(
            action.onSignUpModal({
              visible: false,
            })
          );
          dispatch(
            action.isLogin({
              value: true,
            })
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        let res = err.response;
        if (res.status === 500) {
          message.error(t('500'));
        } else {
          switch (res.data.code) {
            case 400101:
              message.error(t('NoaccountfoundwiththatEmailaddress'));
              break;
            case 400205:
              message.error(t('YourpasswordwasincorrectPleasetryagain'));
              break;
            case 404001:
              message.error(t('NoaccountfoundwiththatEmailaddress'));
              break;
            default:
              message.error(t('500'));
          }
        }
        addDefeatCount();
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      localStorage.getItem('userEmail') &&
      localStorage.getItem('userPassword')
    ) {
      setIsRemember(true);
    }
  }, []);

  const onFinish = (value) => {
    console.log('value', value);
    let formData = new FormData();
    formData.append('email', value.email);
    formData.append('password', value.password);
    let anonymousAuth = Cookies.get('anonymousAuth');
    if (anonymousAuth) {
      formData.append('previous_authorization', anonymousAuth);
    }
    let defeatCount = localStorage.getItem('defeatCount');
    if (defeatCount === undefined || defeatCount < 3) {
      setShow(false);
      loginRequest(formData, value);
    } else {
      setShow(true);
      if (value.verification !== captcha) {
        //message.error(t("Invalidverificationcodepleasereenterthecorrectone"));
      } else {
        loginRequest(formData, value);
      }
    }
  };
  return (
    <div className='emailLogin'>
      <div>
        <div className='loginTitle'>{t('LoginwithEmail')}</div>
        <div className='loginSubTitle'>
          {t('Notaregistereduseryet1')}&nbsp;
          <span onClick={changeIntoSignUp} className='signUpLink'>
            {t('Notaregistereduseryet2')}
          </span>
        </div>
        <div>
          <Form onFinish={onFinish}>
            <Form.Item
              name='email'
              className='formItem'
              validateTrigger='onBlur'
              initialValue={
                localStorage.getItem('userEmail')
                  ? localStorage.getItem('userEmail')
                  : ''
              }
              rules={[
                {
                  required: true,
                  type: 'email',
                  validator: Validator.emailValidator,
                },
              ]}
              getValueFromEvent={(e) => {
                return e.target.value.replace(/\s+/g, '');
              }}
            >
              <Input placeholder={t('Email')} className='inputForm' />
            </Form.Item>
            <Form.Item
              name='password'
              className='formItem'
              validateTrigger='onBlur'
              initialValue={
                localStorage.getItem('userPassword')
                  ? localStorage.getItem('userPassword')
                  : ''
              }
              getValueFromEvent={(e) => {
                return e.target.value.replace(/\s+/g, '');
              }}
              rules={[
                {
                  required: true,
                  validator: Validator.passwordValidator,
                },
              ]}
            >
              <Input.Password
                iconRender={passWordIconRender}
                placeholder={t('Password')}
                className='inputForm'
              />
            </Form.Item>
            {isShow ? (
              <div className='verification'>
                <div className='verificationInput'>
                  <Form.Item
                    name='verification'
                    rules={[
                      {
                        required: true,
                        validator: Validator.emptyValidator,
                      },
                    ]}
                  >
                    <Input placeholder={t('Verificationcode')} />
                  </Form.Item>
                </div>
                <div>
                  <Gverify handleClickCaptcha={handleClickCaptcha} />
                </div>
              </div>
            ) : (
              ''
            )}

            <Form.Item>
              <Checkbox
                className='checkBox'
                defaultChecked={
                  localStorage.getItem('userEmail') &&
                  localStorage.getItem('userPassword')
                }
                onChange={onChange}
              >
                {t('Rememberme')}
              </Checkbox>
            </Form.Item>

            <Form.Item className='loginFormItem'>
              <Button
                loading={loading}
                className='loginBtn'
                type='primary'
                htmlType='submit'
              >
                {t('Login')}
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div onClick={changeIntoForget} className='forgetPassword'>
          {t('ForgotPassword2')}
        </div>
        <div>
          <Divider plain>{t('or')}</Divider>
          <Button
            loading={googleLoading}
            onClick={GoogleLogin}
            className='googleBtn'
            type='default'
            block
          >
            <GoogleLogo className='googleIcon' />
            <div className='btnContent'>{t('ContinuewithGoogle')}</div>
          </Button>
        </div>
      </div>
    </div>
  );
}
